// utils/data.js
// ─────────────────────────────────────────────────────────────────────────────
// IMPORTANT: Category and product names are NO LONGER stored here.
//            They come entirely from the API (DB has EN/HI/GU translations).
//
// This file only contains:
//   1. UI translations (button labels, page titles, form labels, etc.)
//   2. Static testimonials (no API endpoint for these)
// ─────────────────────────────────────────────────────────────────────────────

// ─── UI Translations (EN / HI / GU) ──────────────────────────────────────────
export const T = {
  en: {
    // Nav
    home: "Home",
    about: "About Us",
    products: "Products",
    contact: "Contact",
    admin: "Admin",
    searchPlaceholder: "Search seeds…",
    language: "Language",

    // Hero
    heroTagline: "Premium Quality Seeds for Every Season",
    heroDesc:
      "Trusted by thousands of farmers across Gujarat. Certified, high-yield seeds for vegetables, fruits, flowers and grains.",
    shopNow: "Explore Products",
    contactUs: "Contact Us",
    viewAll: "View All",

    // Home sections
    featuredTitle: "Featured Products",
    featuredSub: "Our most popular and high-demand seeds this season",
    catsTitle: "Seed Categories",
    catsSub: "Browse our wide range of agricultural seeds",
    whyUs: "Why Choose Us?",
    whyUsSub: "Trusted by farmers for quality, reliability and service",
    benefit1: "Certified Quality",
    benefit1d:
      "All seeds tested and certified for germination rate and purity.",
    benefit2: "Local Expertise",
    benefit2d: "30+ years experience in Gujarat's agricultural conditions.",
    benefit3: "Fast Delivery",
    benefit3d: "Quick delivery across Gujarat and neighbouring states.",
    benefit4: "Expert Support",
    benefit4d: "Free consultation and growing guidance from our agronomists.",
    testiTitle: "What Farmers Say",
    testiSub: "Real reviews from real farmers across Gujarat",
    ctaTitle: "Ready to Grow?",
    ctaSub: "Contact us for bulk orders, inquiries and expert advice.",
    getInTouch: "Get In Touch",

    // About
    aboutTitle: "About Danti Wada Beej Kendra",
    aboutDesc:
      "Established in Bhabhar, Gujarat, we have been a trusted name in agricultural seeds for over three decades, serving thousands of farmers with premium certified seeds.",
    mission: "Our Mission",
    missionText:
      "To empower every farmer with the highest quality seeds, ensuring maximum yield and sustainable agriculture.",
    vision: "Our Vision",
    visionText:
      "To be Gujarat's most trusted seed provider, supporting farmers with modern solutions and traditional wisdom.",
    quality: "Quality Assurance",
    qualityText:
      "Every seed batch undergoes rigorous testing including germination tests, purity analysis, and field trials before reaching our customers.",
    yearsExp: "Years of Experience",
    happyFarmers: "Happy Farmers",
    seedVarieties: "Seed Varieties",
    cities: "Cities Served",

    // Products page
    allCats: "All Categories",
    sortBy: "Sort By",
    priceAsc: "Price: Low → High",
    priceDesc: "Price: High → Low",
    newest: "Newest First",
    noProducts: "No products found.",
    inStock: "In Stock",
    limited: "Limited",
    outOfStock: "Out of Stock",
    results: "results",
    viewDetails: "View Details",
    addToInquiry: "Add to Inquiry",
    perPacket: "/ packet",

    // Product detail
    seedType: "Seed Type",
    sku: "SKU",
    weight: "Weight",
    growing: "Growing Instructions",
    sendInquiry: "Send Inquiry",
    related: "Related Products",
    pricePerPacket: "Price per packet",
    season: "Season",
    allSeason: "All Season",
    category: "Category",

    // Contact / forms
    contactTitle: "Contact Us",
    name: "Your Name",
    phone: "Phone Number",
    email: "Email Address",
    message: "Your Message",
    send: "Send Message",
    address: "Address",
    biz: "Business Hours",
    msgSent: "Inquiry sent! We will contact you shortly.",
    sendAnother: "Send Another",

    // Contact info
    addr: "On Tirupati Market Road, Bhabhar, Banaskantha, Gujarat – 385320",
    tel: "+91 9909000682",
    mail: "dantiwadakrushibijkendra@gmail.com",
    hours: "Mon–Sat: 9:00 AM – 6:00 PM\nSunday: 10:00 AM – 2:00 PM",

    // Footer
    footerDesc: "Gujarat's trusted seed supplier since 1990.",
    quickLinks: "Quick Links",
    privacy: "Privacy Policy",
    terms: "Terms & Conditions",
    rights: "All rights reserved",

    // Admin
    dashboard: "Dashboard",
    manageProducts: "Manage Products",
    manageCategories: "Manage Categories",
    manageInquiries: "Manage Inquiries",
    addProduct: "Add Product",
    editProduct: "Edit Product",
    addCategory: "Add Category",
    editCategory: "Edit Category",
    save: "Save",
    cancel: "Cancel",
    update: "Update",
    totalProducts: "Total Products",
    totalCats: "Total Categories",
    pendingInq: "Pending Inquiries",
    logout: "Logout",
    login: "Login",
    password: "Password",
    username: "Username",
    signIn: "Sign In",
    markReplied: "Mark Replied",
    yesDelete: "Yes, Delete",
    goodMorning: "Good morning! 👋",
    happeningToday: "Here's what's happening today.",
    recentInquiries: "Recent Inquiries",
    openMaps: "Open in Google Maps ↗",
    thisWeek: "this week",
    growing: "Growing",
    varieties: "varieties",
    productsLabel: "products",
  },

  hi: {
    home: "होम",
    about: "हमारे बारे में",
    products: "उत्पाद",
    contact: "संपर्क",
    admin: "एडमिन",
    searchPlaceholder: "बीज खोजें…",
    language: "भाषा",

    heroTagline: "हर मौसम के लिए उच्च गुणवत्ता के बीज",
    heroDesc:
      "गुजरात के हजारों किसानों का भरोसा। सब्जियों, फलों, फूलों और अनाज के प्रमाणित, उच्च उपज वाले बीज।",
    shopNow: "उत्पाद देखें",
    contactUs: "संपर्क करें",
    viewAll: "सभी देखें",

    featuredTitle: "विशेष उत्पाद",
    featuredSub: "इस मौसम के सबसे लोकप्रिय बीज",
    catsTitle: "बीज श्रेणियां",
    catsSub: "हमारी कृषि बीजों की विस्तृत श्रृंखला",
    whyUs: "हमें क्यों चुनें?",
    whyUsSub: "गुणवत्ता, विश्वसनीयता और सेवा के लिए किसानों का भरोसा",
    benefit1: "प्रमाणित गुणवत्ता",
    benefit1d: "सभी बीजों का अंकुरण दर और शुद्धता के लिए परीक्षण।",
    benefit2: "स्थानीय विशेषज्ञता",
    benefit2d: "गुजरात की कृषि स्थितियों में 30+ वर्षों का अनुभव।",
    benefit3: "तेज़ डिलीवरी",
    benefit3d: "गुजरात और पड़ोसी राज्यों में त्वरित डिलीवरी।",
    benefit4: "विशेषज्ञ सहायता",
    benefit4d: "हमारे कृषि विशेषज्ञों से मुफ्त परामर्श।",
    testiTitle: "किसान क्या कहते हैं",
    testiSub: "गुजरात के वास्तविक किसानों की समीक्षाएं",
    ctaTitle: "उगाने के लिए तैयार हैं?",
    ctaSub: "थोक ऑर्डर, पूछताछ और विशेषज्ञ सलाह के लिए संपर्क करें।",
    getInTouch: "संपर्क करें",

    aboutTitle: "दांती वाड़ा बीज केंद्र के बारे में",
    aboutDesc:
      "भाभर, गुजरात में स्थापित, हम तीन दशकों से अधिक समय से कृषि बीजों में एक विश्वसनीय नाम रहे हैं।",
    mission: "हमारा मिशन",
    missionText:
      "हर किसान को उच्चतम गुणवत्ता के बीज प्रदान करना, अधिकतम उपज और टिकाऊ कृषि सुनिश्चित करना।",
    vision: "हमारा विजन",
    visionText:
      "गुजरात के सबसे विश्वसनीय बीज प्रदाता बनना, आधुनिक कृषि समाधानों के साथ किसानों का समर्थन करना।",
    quality: "गुणवत्ता आश्वासन",
    qualityText:
      "हर बीज बैच कठोर गुणवत्ता परीक्षण से गुजरता है जिसमें अंकुरण परीक्षण, शुद्धता विश्लेषण शामिल हैं।",
    yearsExp: "वर्षों का अनुभव",
    happyFarmers: "खुश किसान",
    seedVarieties: "बीज किस्में",
    cities: "सेवित शहर",

    allCats: "सभी श्रेणियां",
    sortBy: "क्रमबद्ध करें",
    priceAsc: "मूल्य: कम → अधिक",
    priceDesc: "मूल्य: अधिक → कम",
    newest: "नवीनतम पहले",
    noProducts: "कोई उत्पाद नहीं मिला।",
    inStock: "स्टॉक में",
    limited: "सीमित",
    outOfStock: "स्टॉक खत्म",
    results: "परिणाम",
    viewDetails: "विवरण देखें",
    addToInquiry: "पूछताछ जोड़ें",
    perPacket: "/ पैकेट",

    seedType: "बीज का प्रकार",
    sku: "SKU",
    weight: "वजन",
    growing: "उगाने के निर्देश",
    sendInquiry: "पूछताछ भेजें",
    related: "संबंधित उत्पाद",
    pricePerPacket: "प्रति पैकेट मूल्य",
    season: "मौसम",
    allSeason: "सभी मौसम",
    category: "श्रेणी",

    contactTitle: "संपर्क करें",
    name: "आपका नाम",
    phone: "फोन नंबर",
    email: "ईमेल पता",
    message: "आपका संदेश",
    send: "संदेश भेजें",
    address: "पता",
    biz: "व्यापार के घंटे",
    msgSent: "पूछताछ भेज दी गई! हम जल्द ही संपर्क करेंगे।",
    sendAnother: "और भेजें",

    addr: "तिरुपति मार्केट रोड पर, भाभर, बनासकांठा, गुजरात – 385320",
    tel: "+91 9909000682",
    mail: "dantiwadakrushibijkendra@gmail.com",
    hours: "सोम–शनि: 9:00 AM – 6:00 PM\nरविवार: 10:00 AM – 2:00 PM",

    footerDesc: "1990 से गुजरात के विश्वसनीय बीज आपूर्तिकर्ता।",
    quickLinks: "त्वरित लिंक",
    privacy: "गोपनीयता नीति",
    terms: "नियम और शर्तें",
    rights: "सर्वाधिकार सुरक्षित",

    dashboard: "डैशबोर्ड",
    manageProducts: "उत्पाद प्रबंधन",
    manageCategories: "श्रेणी प्रबंधन",
    manageInquiries: "पूछताछ प्रबंधन",
    addProduct: "उत्पाद जोड़ें",
    editProduct: "उत्पाद संपादित करें",
    addCategory: "श्रेणी जोड़ें",
    editCategory: "श्रेणी संपादित करें",
    save: "सहेजें",
    cancel: "रद्द करें",
    update: "अपडेट करें",
    totalProducts: "कुल उत्पाद",
    totalCats: "कुल श्रेणियां",
    pendingInq: "लंबित पूछताछ",
    logout: "लॉगआउट",
    login: "लॉगिन",
    password: "पासवर्ड",
    username: "उपयोगकर्ता नाम",
    signIn: "साइन इन",
    markReplied: "उत्तर दिया गया",
    yesDelete: "हाँ, हटाएं",
    goodMorning: "सुप्रभात! 👋",
    happeningToday: "आज क्या हो रहा है।",
    recentInquiries: "हालिया पूछताछ",
    openMaps: "Google Maps में खोलें ↗",
    thisWeek: "इस सप्ताह",
    growing: "बढ़ रहे हैं",
    varieties: "किस्में",
    productsLabel: "उत्पाद",
  },

  gu: {
    home: "હોમ",
    about: "અમારા વિશે",
    products: "ઉત્પાદનો",
    contact: "સંપર્ક",
    admin: "એડમિન",
    searchPlaceholder: "બીજ શોધો…",
    language: "ભાષા",

    heroTagline: "દરેક ઋતુ માટે ઉચ્ચ ગુણવત્તાના બીજ",
    heroDesc:
      "ગુજરાતના હજારો ખેડૂતોનો ભરોસો. શાકભાજી, ફળ, ફૂલ અને અનાજ માટે પ્રમાણિત, ઉચ્ચ ઉત્પાદન બીજ.",
    shopNow: "ઉત્પાદનો જુઓ",
    contactUs: "સંપર્ક કરો",
    viewAll: "બધા જુઓ",

    featuredTitle: "વિશેષ ઉત્પાદનો",
    featuredSub: "આ ઋતુના અમારા સૌથી લોકપ્રિય બીજ",
    catsTitle: "બીજ શ્રેણીઓ",
    catsSub: "અમારી વ્યાપક કૃષિ બીજ શ્રેણી જુઓ",
    whyUs: "અમને શા માટે પસંદ કરો?",
    whyUsSub: "ગુણવત્તા, વિશ્વસનીયતા અને સેવા માટે ખેડૂતોનો ભરોસો",
    benefit1: "પ્રમાણિત ગુણવત્તા",
    benefit1d: "તમામ બીજ અંકુરણ દર અને શુદ્ધતા માટે પરીક્ષિત.",
    benefit2: "સ્થાનિક નિષ્ણાત",
    benefit2d: "ગુજરાતની કૃષિ સ્થિતિઓમાં 30+ વર્ષનો અનુભવ.",
    benefit3: "ઝડપી ડિલિવરી",
    benefit3d: "ગુજરાત અને પડોશી રાજ્યોમાં ઝડપી ડિલિવરી.",
    benefit4: "નિષ્ણાત સહાય",
    benefit4d: "અમારા કૃષિ નિષ્ણાતો પાસેથી મફત પરામર્શ.",
    testiTitle: "ખેડૂતો શું કહે છે",
    testiSub: "ગુજરાતના વાસ્તવિક ખેડૂતોના અભિપ્રાય",
    ctaTitle: "ઉગાડવા માટે તૈયાર?",
    ctaSub: "જથ્થાબંધ ઓર્ડર, પૂછપરછ અને નિષ્ણાત સલાહ માટે સંપર્ક કરો.",
    getInTouch: "સંપર્ક કરો",

    aboutTitle: "દાંતી વાડા બીજ કેન્દ્ર વિશે",
    aboutDesc:
      "ભાભર, ગુજરાતમાં સ્થાપિત, અમે ત્રણ દાયકાઓથી વધુ સમયથી કૃષિ બીજમાં વિશ્વસ્ત નામ છીએ.",
    mission: "અમારું મિશન",
    missionText:
      "દરેક ખેડૂતને ઉચ્ચતમ ગુણવત્તાના બીજ પ્રદાન કરવા, મહત્તમ ઉત્પાદન અને ટકાઉ કૃષિ સુનિશ્ચિત કરવા.",
    vision: "અમારું વિઝન",
    visionText:
      "ગુજરાતનું સૌથી વિશ્વસ્ત બીજ પ્રદાતા બનવું, આધુનિક ઉકેલો સાથે ખેડૂતોને સહાય કરવી.",
    quality: "ગુણવત્તા ખાતરી",
    qualityText:
      "દરેક બીજ બૅચ કઠોર ગુણવત્તા પરીક્ષણમાંથી પસાર થાય છે, જેમાં અંકુરણ પરીક્ષણ, શુદ્ધતા વિશ્લેષણ સામેલ છે.",
    yearsExp: "વર્ષોનો અનુભવ",
    happyFarmers: "ખુશ ખેડૂતો",
    seedVarieties: "બીજ જાતો",
    cities: "સેવા આપેલ શહેરો",

    allCats: "તમામ શ્રેણીઓ",
    sortBy: "ક્રમ",
    priceAsc: "ભાવ: ઓછો → વધુ",
    priceDesc: "ભાવ: વધુ → ઓછો",
    newest: "નવીનતમ પ્રથમ",
    noProducts: "કોઈ ઉત્પાદન મળ્યું નહીં.",
    inStock: "સ્ટૉકમાં",
    limited: "મર્યાદિત",
    outOfStock: "સ્ટૉક ખૂટ્યો",
    results: "પરિણામ",
    viewDetails: "વિગતો જુઓ",
    addToInquiry: "પૂછપરછ ઉમેરો",
    perPacket: "/ પૅકેટ",

    seedType: "બીજનો પ્રકાર",
    sku: "SKU",
    weight: "વજન",
    growing: "ઉગાડવાની સૂચનાઓ",
    sendInquiry: "પૂછપરછ મોકલો",
    related: "સંબંધિત ઉત્પાદનો",
    pricePerPacket: "પ્રતિ પૅકેટ ભાવ",
    season: "ઋતુ",
    allSeason: "તમામ ઋતુ",
    category: "શ્રેણી",

    contactTitle: "સંપર્ક કરો",
    name: "આપનું નામ",
    phone: "ફોન નંબર",
    email: "ઈ-મેઈલ",
    message: "આપનો સંદેશ",
    send: "સંદેશ મોકલો",
    address: "સરનામું",
    biz: "વ્યવસાયના કલાકો",
    msgSent: "પૂછપરછ મોકલાઈ! અમે ટૂંક સમયમાં સંપર્ક કરીશું.",
    sendAnother: "બીજો મોકલો",

    addr: "તિરૂપતિ માર્કેટ રોડ પર, ભાભર, બનાસકાંઠા, ગુજરાત – 385320",
    tel: "+91 9909000682",
    mail: "dantiwadakrushibijkendra@gmail.com",
    hours: "સોમ–શનિ: 9:00 AM – 6:00 PM\nરવિવાર: 10:00 AM – 2:00 PM",

    footerDesc: "1990 થી ગુજરાતના વિશ્વસ્ત બીજ સપ્લાયર.",
    quickLinks: "ઝડપી લિંક",
    privacy: "ગોપનીયતા નીતિ",
    terms: "નિયમો અને શરતો",
    rights: "સર્વ હક્કો સુરક્ષિત",

    dashboard: "ડૅશબૉર્ડ",
    manageProducts: "ઉત્પાદન વ્યવસ્થાપન",
    manageCategories: "શ્રેણી વ્યવસ્થાપન",
    manageInquiries: "પૂછપરછ વ્યવસ્થાપન",
    addProduct: "ઉત્પાદન ઉમેરો",
    editProduct: "ઉત્પાદન સંપાદિત",
    addCategory: "શ્રેણી ઉમેરો",
    editCategory: "શ્રેણી સંપાદિત",
    save: "સેવ",
    cancel: "રદ",
    update: "અપડેટ",
    totalProducts: "કુલ ઉત્પાદનો",
    totalCats: "કુલ શ્રેણીઓ",
    pendingInq: "બાકી પૂછપરછ",
    logout: "લૉગઆઉટ",
    login: "લૉગિન",
    password: "પાસવર્ડ",
    username: "વપરાશકર્તા નામ",
    signIn: "સાઇન ઇન",
    markReplied: "જવાબ આપ્યો",
    yesDelete: "હા, કાઢો",
    goodMorning: "સુપ્રભાત! 👋",
    happeningToday: "આજે શું ચાલી રહ્યું છે.",
    recentInquiries: "તાજી પૂછપરછ",
    openMaps: "Google Maps માં ખોલો ↗",
    thisWeek: "આ અઠવાડિયે",
    growing: "વૃદ્ધિ",
    varieties: "જાતો",
    productsLabel: "ઉત્પાદન",
  },
};

// t(lang, key) — used in App.jsx to build the t() helper
export const t = (lang, key) => T[lang]?.[key] ?? T.en[key] ?? key;

// ─── Testimonials (static — no API endpoint for these) ───────────────────────
export const TESTIMONIALS = [
  {
    id: 1,
    name: "Rameshbhai Patel",
    loc: "Surat, Gujarat",
    rating: 5,
    msg: {
      en: "Excellent quality seeds! My tomato yield doubled. Highly recommended!",
      hi: "उत्कृष्ट बीज! टमाटर की उपज दोगुनी। दृढ़ता से अनुशंसित!",
      gu: "ઉત્કૃષ્ટ ગુણવત્તા! ઉત્પાદન બમણું. ભારપૂર્વક ભલામણ!",
    },
  },
  {
    id: 2,
    name: "Sureshbhai Desai",
    loc: "Bhavnagar, Gujarat",
    rating: 5,
    msg: {
      en: "Best seed supplier in Gujarat. Fast delivery and genuine certified seeds. My farm is thriving!",
      hi: "गुजरात में सबसे अच्छे बीज। तेज़ डिलीवरी और असली प्रमाणित बीज।",
      gu: "ગુજરાતમાં શ્રેષ્ઠ. ઝડપી ડિલિવરી અને અસલ પ્રમાણિત બીજ.",
    },
  },
  {
    id: 3,
    name: "Kalubhai Solanki",
    loc: "Anand, Gujarat",
    rating: 5,
    msg: {
      en: "Using their seeds for 5 years. Germination rate is excellent and yield is always high.",
      hi: "5 साल से उनके बीज। अंकुरण दर उत्कृष्ट और उपज हमेशा उच्च।",
      gu: "5 વર્ષથી ઉપયોગ. અંકુરણ ઉત્કૃષ્ટ અને ઉત્પાદન હંમેશા ઊંચું.",
    },
  },
];
// ─────────────────────────────────────────────────────────────────────────────
// NOTE: CATEGORIES constant removed — all category data comes from the API.
//       Components that previously imported CATEGORIES now use categoryService.getAll()
// ─────────────────────────────────────────────────────────────────────────────
